<template>
    <v-card>
        <v-card-title class="font-italic grey--text darken-3 text-uppercase">{{ $t('price&quantity') }}</v-card-title>
        <v-card-text class="pb-0">
            <v-row>
                <v-col :cols="fieldWidth * 2" :md="fieldWidth" class="pb-0">
                    <v-text-field
                        class="py-0 my-0"
                        :value="price"
                        :label="$t('price')"
                        disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="4" md="2" class="pb-0" v-if="orderData.commissionSum > 0">
                    <v-text-field
                        class="py-0 my-0"
                        :value="orderData.commissionSum.toFixed(2)"
                        :label="$t('commission')"
                        disabled
                    ></v-text-field>
                </v-col>
                <v-col :cols="fieldWidth * 2" :md="fieldWidth" class="pb-0">
                    <v-text-field
                        class="py-0 my-0"
                        :value="orderData.currencyName.toUpperCase()"
                        :label="$t('currency')"
                        disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="6" md="3" class="pb-0">
                    <v-text-field
                        class="py-0 my-0"
                        :value="unitValue"
                        :label="$t('quantity')"
                        disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="6" md="3" class="pb-0">
                    <v-text-field
                        class="py-0 my-0"
                        :value="discountValue"
                        :label="$t('discount')"
                        disabled
                    ></v-text-field>
                </v-col>
                <v-col clos="12" class="caption font-italic text-center pt-0 font-weight-bolder">
                    {{ orderData.withNds ? $t('priceWithNds') : $t('priceWithoutNds') }}
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import OrderExtendInfo from "../../../mixins/OrderExtendInfo"

export default {
    name: "ExtendPriceInfo",
    mixins: [OrderExtendInfo],
    computed: {
        discountValue() {
            return this.orderData.discount ? this.orderData.discount + '%' : null;
        },
        price() {
            return this.orderData.priceDiscounted || this.orderData.price;
        },
        unitValue() {
            const minValue = this.orderData.minValue || 1;
            const quantity = this.orderData.quantity || 1;

            return minValue * quantity * this.orderData.packValue + ' ' + this.orderData.unitName;
        },
        fieldWidth() {
            return this.orderData.commissionSum > 0 ? 2 : 3;
        }
    }
}
</script>
